<script setup>
import QuoteGrid from '@/components/garage/QuoteGrid.vue'
</script>
<template>
  <quote-grid />
</template>
